var styleDataHash = "f832854f";
const injectCss = (() => {
  var css = `@charset "UTF-8";.U4bze,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.m32X6{background-color:#fff;border-radius:var(--ricos-internal-toolbar-floating-border-radius,8px);bottom:12px;box-shadow:0 0 6px 0 rgba(0,6,36,.1),0 2px 4px 0 rgba(0,6,36,.05);box-sizing:border-box;left:50%;padding:3px;pointer-events:none;position:absolute;transform:translateX(-50%);user-select:none;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;z-index:1000}.In7Ez,.m32X6{align-items:center;display:flex;font-family:var(--ricos-settings-text-font-family,Madefor,"Helvetica Neue",Helvetica,Arial,メイリオ,meiryo,"ヒラギノ角ゴ pro w3","hiragino kaku gothic pro",sans-serif);font-size:14px}.In7Ez{background:transparent;border:transparent;border-radius:var(--ricos-internal-toolbar-button-border-radius,6px);color:var(--ricos-internal-toolbar-button-text-color,#000);cursor:pointer;gap:3px;height:30px;justify-content:center;margin:0;min-width:30px;min-width:max-content;padding-inline-end:6px;padding-inline-start:6px;pointer-events:auto}@media (hover:hover){.In7Ez:hover:not([disabled]){background-color:var(--ricos-internal-toolbar-button-background-color-hover,#e7f0ff);color:var(--ricos-internal-toolbar-button-text-color-hover,#116dff)}}.In7Ez._1ZiOH{background-color:var(--ricos-internal-toolbar-button-background-color-active,#d6e6fe);color:var(--ricos-settings-text-color,var(--ricos-action-color-fallback,#116dff));fill:var(--ricos-settings-text-color,var(--ricos-action-color-fallback,#116dff))}.In7Ez._1ZiOH svg{fill:var(--ricos-settings-icons-color,currentColor);color:var(--ricos-settings-icons-color,currentColor)}.In7Ez.PmC-B{cursor:default;opacity:.4;pointer-events:none}.In7Ez.eq-8D{height:36px;min-width:36px}.In7Ez.VWULd{padding-inline-end:12px}.In7Ez.dM5WU{min-width:30px;padding-inline-end:0;padding-inline-start:0}.In7Ez:focus{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}.In7Ez .AfmjW{flex-shrink:0}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var add_caption_button_default = {
  "fontElementMap": "U4bze",
  "addCaptionButtonContainer": "m32X6",
  "addCaptionButton": "In7Ez",
  "active": "_1ZiOH",
  "disabled": "PmC-B",
  "mobile": "eq-8D",
  "withIcon": "VWULd",
  "iconOnly": "dM5WU",
  "icon": "AfmjW"
};
export {
  add_caption_button_default as default,
  injectCss
};
//# sourceMappingURL=add-caption-button-scss.js.map
